































































































































































































































































































































































































































import { Vue, photosUrlEnum } from "../../constants/constants";
import { KEYS, getRemoteConfigAsBoolean, ensureRemoteConfigInitialize } from "../../firebase";
import {
  ifItemSizeExist,
  toFixedPrice,
  counter,
  validateRestaurantMinOrderValue,
  updatePhotosURL,
  URLBuilder,
  isRTL,
} from "../../helpers";
import { staticContent } from "../../localisation/detect-lang";
import {
  BasketLoadersEnum,
  genericErrorsEnum,
} from "../../models/basket.model";
import {
  getRemoteConfigAsBoolean,
  ensureRemoteConfigInitialize,
  getRemoteConfigAsString,
} from "../../firebase";
var modalOpened = false;

export default Vue.component("basket-view", {
  data() {
    return {
      staticContent,
      URLBuilder,
      basketLoader: BasketLoadersEnum,
      photosUrlEnum,
      shouldShowDeliveryIcon: false,
      shouldShowServiceIcon: false,
      shouldShowSubtotal: false,
    };
  },
  mounted() {
    this.fetchShouldShowFeesIcons();
    this.fetchFeesMessages();
    this.checkSubtotalConfig();
  },
  computed: {
    isUser() {
      return this.$store.getters.isUser;
    },
    basketItemModal() {
      return this.$store.getters.getBasketItemModal;
    },
    itemCount() {
      return this.$store.state.basketCompact.data.itemCount;
    },
    basketCompact() {
      return this.$store.state.basketCompact;
    },
    group() {
      return this.$store.state.groupBasket;
    },
    basket() {
      return this.$store.state.basket;
    },
    getBasketItemsCount() {
      return this.$store.getters.getBasketItemsCount;
    },
  },
  methods: {
    onInfoIconHover(type) {
      this.$root.onInfoIconHover(type);
    },
    fetchShouldShowFeesIcons() {
      ensureRemoteConfigInitialize().then(() => {
        this.shouldShowDeliveryIcon = getRemoteConfigAsBoolean(
          "Show_info_delivery"
        );
        this.shouldShowServiceIcon = getRemoteConfigAsBoolean(
          "Show_info_service"
        );
      });
    },
    fetchFeesMessages() {
      const direction = isRTL ? "AR" : "EN";
      ensureRemoteConfigInitialize().then(() => {
        this.deliveryFeesMessage = getRemoteConfigAsString(
          `Message_info_delivery_${direction}`
        );
        this.serviceFeesMessage = getRemoteConfigAsString(
          `Message_info_service_${direction}`
        );
      });
    },
    updatePhotosURL(url, version, ext = this.photosUrlEnum.ext.JPG) {
      return updatePhotosURL(url, version, ext);
    },
    flatItemExtras(extraCategories) {
      let extrasFlattened = [];
      extraCategories.forEach((exCategory) => {
        extrasFlattened = [...extrasFlattened, ...exCategory.extraItems];
      });
      return extrasFlattened;
    },
    validateRestaurantMinOrderValue() {
      return validateRestaurantMinOrderValue(
        this.basket.data.receipt.subTotal,
        this.basket.data.minimumOrderValue
      );
    },
    removeAll() {
      if (navigator.onLine) {
        this.$store
          .dispatch("REMOVE_ALL_ITEMS_FROM_BASKET")
          .then(() => {
            this.$store.commit("updateBasketIsGroup", false);
            this.$root.groupSummaryInterval &&
              clearInterval(this.$root.groupSummaryInterval);
            this.$root.compactBasketInterval &&
              clearInterval(this.$root.compactBasketInterval);
          })
          .catch(() => {
            this.$root.handleGenericErrors(
              genericErrorsEnum.generic,
              "remove-all"
            );
          })
          .catch(() => {
            this.hasError = true;
          });
      } else {
        this.$root.handleGenericErrors(
          genericErrorsEnum.internet,
          "remove-all"
        );
      }
    },
    convertToGroup() {
      if (navigator.onLine) {
        this.$root.pushMixpanelEvent(
          this.$root.mixpanelEvents.convertToGroup.event,
          this.$root.mixpanelEvents.convertToGroup.properties(
            this.basket.ref.restaurant.name
              ? this.basket.ref.restaurant.name
              : "N/A"
          )
        );

        this.$store
          .dispatch("CONVERT_USER_BASKET_TO_GROUP")
          .then(() => {
            this.$root.groupURL =
              window.location.origin + (this.group && this.group.data.link);
            this.$root.modalToggler("start-grouping-modal", "show");
          })
          .catch((e) => {
            this.$root.handleGenericErrors(
              genericErrorsEnum.generic,
              "convert"
            );
          });
      } else {
        this.$root.handleGenericErrors(genericErrorsEnum.internet, "convert");
      }
    },
    checkoutGoToStep1() {
      this.$store.commit("setCheckoutStep", 1);
      this.$store.dispatch(`GET_USER_BASKET_ADDRESSES`);
    },
    openCheckoutModal() {
      if (
        this.$root.basketHasError &&
        this.$root.basketError.basketErrorMsg.showModal
      ) {
        this.$store.dispatch("GET_USER_BASKET_SUMMARY").then(() => {
          if (
            this.$root.basketHasError &&
            this.$root.basketError.basketErrorMsg.showModal
          ) {
            this.$root.basketErrors();
          } else this.openCheckoutModal();
        });
      } else {
        if (navigator.onLine) {
          this.$store.dispatch("GET_USER_BASKET")
            .then(() => {
              this.$root.pushAnalyticsEvent(
                this.$root.analyticsEvents.ordering.category,
                this.$root.analyticsEvents.ordering.events.proceedToCheckout,
                this.$root.analyticsEvents.ordering.labels.basketUUID(
                  this.basket.uuid
                )
              );
              window["gtag"]("event", "begin_checkout");

              this.$root.pushMixpanelEvent(
                this.$root.mixpanelEvents.mainCheckoutScreen.event,
                this.$root.mixpanelEvents.mainCheckoutScreen.properties(
                  this.basket.ref.restaurant
                    ? this.basket.ref.restaurant.name
                    : "N/A",
                  this.basket.ref.address &&
                    this.basket.ref.address.ref.areaUUID
                    ? this.$root.flatAreas[this.basket.ref.address.ref.areaUUID]
                        .name
                    : this.basket.ref.zoneUUID &&
                        this.$root.flatAreas[
                          this.$root.flatZones[this.basket.ref.zoneUUID]
                            .areaUUID
                        ].name,
                  "Individual",
                  this.basket.data.receipt.deliveryCharges.serviceFees !== 0,
                  this.basket.data.receipt.deliveryCharges.serviceFees
                )
              );

              this.basket.ref.address && this.basket.ref.address.uuid
                ? this.$root.checkoutGoToStep2(this.basket.ref.address.uuid)
                : this.checkoutGoToStep1();

              this.$store.commit("updateCheckoutVisibility", true);

              document.documentElement.clientWidth <= 1024 &&
                this.$store.commit("changeBasketVisibility", false);
              this.$root.modalToggler("checkout-modal", "show");
              if (window["fcWidget"] && !window["fcWidget"].isInitialized()) {
                try {
                  this.$root.initChat();
                } catch (error) {
                  console.log(`Error while init FreshChat`, error);
                }
              }
            })
            .catch((error) => {
              if (
                error.response.data.error === "BRANCH_UNAVAILABLE" ||
                error.response.data.error === "RESTAURANT_UNAVAILABLE"
              ) {
                this.$store.commit("updateBasketDataExist", false);
              } else {
                this.$store.commit("updateCheckoutVisibility", true);

                document.documentElement.clientWidth <= 1024 &&
                  this.$store.commit("changeBasketVisibility", false);
                this.$root.modalToggler("checkout-modal", "show");
                if (window["fcWidget"] && !window["fcWidget"].isInitialized()) {
                  try {
                    this.$root.initChat();
                  } catch (error) {
                    console.log(`Error while init FreshChat`, error);
                  }
                }
                this.checkoutGoToStep1();
              }
            });
        } else {
          this.$root.handleGenericErrors(genericErrorsEnum.internet);
        }
      }
    },
    shouldIOpenCheckOutModal() {
      this.$root.toggleBasket()
      this.$store.state.unavailableItems.length == 0
        ? this.openCheckoutModal()
        : this.$root.modalToggler("bulk-remove", "show");
    },

    showAreaZoneModal() {
      this.$root.createBasketOpen = true;
      this.$root.modalToggler("create-basket-modal", "show");
      this.$store.commit("updateAreaZoneVisibility", true);
    },
    showCreateBasket() {
      this.$root.createBasketOpen = true;
      this.$root.modalToggler("create-basket-modal", "show");
    },
    closeBasket() {
      this.$root.closeBasket();
    },
    toFixedPrice(price) {
      return this.$root.toFixedPrice(price);
    },
    getBasketAddress() {
      let address: string = null;

      let zoneName: string =
        this.basket.ref.address && this.basket.ref.address.ref.zoneUUID
          ? this.$root.flatZones[this.basket.ref.address.ref.zoneUUID].name
          : this.basket.ref.zoneUUID &&
            this.$root.flatZones[this.basket.ref.zoneUUID].name;

      let areaName: string =
        this.basket.ref.address && this.basket.ref.address.ref.areaUUID
          ? this.$root.flatAreas[this.basket.ref.address.ref.areaUUID].name
          : this.basket.ref.zoneUUID &&
            this.$root.flatAreas[
              this.$root.flatZones[this.basket.ref.zoneUUID].areaUUID
            ].name;

      address = `${zoneName}, ${areaName}`;

      return address;
    },
    getOrderTotalPrice() {
      const price =  this.shouldShowSubtotal ? this.basket.data.receipt.subTotal : this.basket.data.receipt.total;
      return this.toFixedPrice(price)
    },
    checkSubtotalConfig() {
      ensureRemoteConfigInitialize().then(() => {
        this.shouldShowSubtotal = getRemoteConfigAsBoolean(KEYS.Show_SubTotal_in_Basket);
      })
    }
  },
});
